import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const { Cell } = Table;

const DurationLimitCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props}>{rowData[dataKey] > 0 ? rowData[dataKey] : 'No Limit'}</Cell>
);

DurationLimitCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number
  }),
  dataKey: PropTypes.string.isRequired
};

DurationLimitCell.defaultProps = {
  rowData: null
};

export default DurationLimitCell;
